import { createBrowserClient } from '@supabase/ssr'

// Намеренно НЕ параметризован <Database> — существующий клиентский код писался
// под `Database = any`. Реальные типы используются в data-слое (репозиториях).
// См. комментарий в lib/supabase/server.ts.
export function createClient() {
  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
  )
}
